import React from "react";
import ReactDOMClient from "react-dom/client";
import { PageProduit } from "./screens/PageProduit";
// import i18n (needs to be bundled)
import './i18n';

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(<PageProduit />);
